import {
  Container,
  Distribute,
  Icon,
  Spacer,
  SvgSettings,
  Switch,
  Text,
  TooltipBox,
} from '@loomhq/lens';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { ToggleLayer } from 'react-laag';
import { useDispatch, useSelector } from 'react-redux';
import ResizeObserver from 'resize-observer-polyfill';

import { requestVideoPlayerPlaybackRate } from 'actions/videoPlayer';
import * as analytics from 'utilities/analytics';

import ControlBarButton from '../control-bar-button';
import { PLAYBACK_RATES_MAP } from '../../constants/playback';
import { START_SCREEN_SPEED_SELECTOR_CLICK } from '../../../../constants/events';

import styles from './styles.module.css';

function OptionsMenu({ canShowCaptions, showCaptions, setShowCaptions }) {
  const playbackRate = useSelector(state => state.video_player.playback_rate);
  const dispatch = useDispatch();

  function onRateClick(event, rate) {
    event.stopPropagation();
    analytics.track(START_SCREEN_SPEED_SELECTOR_CLICK, { rate });
    dispatch(requestVideoPlayerPlaybackRate(rate));
  }

  return (
    <Distribute direction="column" alignment="stretch" gap="small">
      <Container padding="xsmall">
        <Text size="medium" fontWeight="medium">
          Playback Speed (s)
        </Text>
      </Container>
      <Container padding="xsmall">
        {PLAYBACK_RATES_MAP.map(rateObj => {
          const isCurrentRate = rateObj.rate === playbackRate;

          return (
            <button
              className={classNames(
                styles.pillButton,
                isCurrentRate && styles.pillButtonSelected
              )}
              onClick={e => onRateClick(e, rateObj.rate)}
              key={rateObj.rate}
            >
              <Text size="medium" fontWeight="medium">
                {rateObj.display}
              </Text>
            </button>
          );
        })}
      </Container>
      <Spacer bottom="small" />
      {canShowCaptions && (
        <Container padding="xsmall">
          <Distribute isSpread alignment="center">
            <Text htmlTag="div" size="medium" fontWeight="medium">
              Closed Captions (a)
            </Text>
            <Spacer right="xlarge" />
            <Switch
              isActive={showCaptions}
              onChange={e => setShowCaptions(e.target.checked)}
            />
          </Distribute>
        </Container>
      )}
    </Distribute>
  );
}

export default function CompactOptionsButton({
  controlBarExpanded,
  canShowCaptions,
  showCaptions,
  setShowCaptions,
}) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!controlBarExpanded) {
      setIsOpen(false);
    }
  }, [controlBarExpanded]);

  const hoverTagText = 'Playback controls';

  return (
    <ToggleLayer
      ResizeObserver={ResizeObserver}
      isOpen={isOpen}
      onOutsideClick={() => setIsOpen(false)}
      placement={{
        anchor: 'TOP_RIGHT',
        autoAdjust: true,
      }}
      renderLayer={({ layerProps, isOpen }) =>
        controlBarExpanded &&
        isOpen && (
          <TooltipBox className={styles.optionsPanel} layerProps={layerProps}>
            <OptionsMenu
              canShowCaptions={canShowCaptions}
              showCaptions={showCaptions}
              setShowCaptions={setShowCaptions}
            />
          </TooltipBox>
        )
      }
    >
      {({ triggerRef, toggle }) => (
        <ControlBarButton
          ref={triggerRef}
          className="video-player-compact-options-button"
          hoverTagText={hoverTagText}
          onClick={() => {
            setIsOpen(!isOpen);
            toggle();
          }}
        >
          <div>
            <Icon
              className="control-bar-button-icon"
              color="white"
              icon={<SvgSettings />}
            />
          </div>
        </ControlBarButton>
      )}
    </ToggleLayer>
  );
}
